import React from 'react';
import { useStoreConfigContext } from '/src/providers';
import * as styles from './styles.scss'

const Notice = ({ className }) => {
    const { translate } = useStoreConfigContext();

    return (
        <div className={`${styles.wrapper}${className ? ` ${className}` : ''}`}>
            <div className={styles.notice}>
                <div className={styles.marker}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: translate('%1 is Not Owned by or Affiliated with %2 or %3', `<span class="${styles.name}">BuyWholefoodsOnline</span>`, 'Amazon', 'Whole Foods Market'),
                        }}
                    />
                </div>
            </div>
        </div>
    )
};

export default Notice;
